export default __webpack_public_path__ + "static/media/RTR200FI_LateralDer.84748a66.webp";